import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface AiSearchKeyType {
  aiPoweredCLIPSearch: LocalesKey;
  aiPoweredSearch20: LocalesKey;
  aiPoweredSearch30: LocalesKey;
  aiPoweredSearch: LocalesKey;
  aiPoweredSearchDetect: LocalesKey;
  bestMatchesForDetectedObjects: LocalesKey;
  bestMatch: LocalesKey;
  moreMatches: LocalesKey;
  showMoreMatches: LocalesKey;
  hideMoreMatches: LocalesKey;
  closeMatches: LocalesKey;
  findAlternatives: LocalesKey;
  findSimilar: LocalesKey;
  findProducts: LocalesKey;
  imageSearch: LocalesKey;
  objectsFoundInTheSourceImage: LocalesKey;
  pleaseUploadASinglePhoto: LocalesKey;
  pleaseUploadPhoto: LocalesKey;
  search: LocalesKey;
  searchInImage: LocalesKey;
  sourceImage: LocalesKey;
  sourceProduct: LocalesKey;
  uploadAPhotoOfARoom: LocalesKey;
  uploadAPhotoOfYourFurnitureAndWellHelpYouFindMatchingItems: LocalesKey;
}

export const aiSearchKeys = keyPathMirror<AiSearchKeyType, string>(
  {
    aiPoweredCLIPSearch: null,
    aiPoweredSearch20: null,
    aiPoweredSearch30: null,
    aiPoweredSearch: null,
    aiPoweredSearchDetect: null,
    bestMatchesForDetectedObjects: null,
    bestMatch: null,
    moreMatches: null,
    showMoreMatches: null,
    hideMoreMatches: null,
    closeMatches: null,
    findAlternatives: null,
    findSimilar: null,
    findProducts: null,
    imageSearch: null,
    objectsFoundInTheSourceImage: null,
    pleaseUploadASinglePhoto: null,
    pleaseUploadPhoto: null,
    search: null,
    searchInImage: null,
    sourceImage: null,
    sourceProduct: null,
    uploadAPhotoOfARoom: null,
    uploadAPhotoOfYourFurnitureAndWellHelpYouFindMatchingItems: null
  },
  'models.aiSearch.'
);
